module.exports = __webpack_public_path__ + "img/active.55aead01.png";